import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ScenarioSectionProp } from ".";
import { AMOUNT_UTIL } from "../../../../../utils/amount.utils";
import UTIL from "../../../../../utils/utils";


const RecoverySection = (props: ScenarioSectionProp) => {


    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbRecoveryStatus")}
                    >
                        {UTIL.getRecoveryStatusName(data.expected_recovery_status)}
                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item>
                        <Row>
                            <Col span={16}>
                                <label className="form-label">{t("Scenario.lbInsuranceRecoveryAmount")}</label>
                            </Col>
                            <Col span={8}>
                                <p className="text-amount">
                                    {AMOUNT_UTIL.convertNumericToFormattedAmount(data.insurance_recovery_amount)}
                                </p>
                            </Col>
                        </Row>

                    </Form.Item>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <Form.Item>
                        <Row>
                            <Col span={16}>
                                <label className="form-label">{t("Scenario.lbOtherRecoveryAmount")}</label>
                            </Col>
                            <Col span={8}>
                                <p className="text-amount">
                                    {AMOUNT_UTIL.convertNumericToFormattedAmount(data.other_recovery_amount)}
                                </p>
                            </Col>
                        </Row>

                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 24]}>
                <Col span={24}>
                    <Form.Item
                        label={t("Scenario.lbRecoveryDescription")}
                    >
                        <span>{data.recovery_description}</span>
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[12, 12]}>
                <Col span={24} className="text-total">
                    <p className="green-text">{t("ControlFailure.lbTotalRecovery")}</p>
                    <span className="green-text">
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(data.total_recovery)}
                    </span>
                </Col>
                <Col span={24} className="text-total">
                    <p>{t("ControlFailure.lbNetLoss")}</p>
                    <span>
                        {AMOUNT_UTIL.convertNumericToFormattedAmount(data.net_loss)}
                    </span>
                </Col>
            </Row>

        </div>
    )
}

export default RecoverySection;